var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgLink = function SvgLink(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "link_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,0C4.5,0,0,4.5,0,10s4.5,10,10,10s10-4.5,10-10S15.5,0,10,0z M9.5,14l-0.5,0.5c-0.4,0.5-1.1,0.7-1.7,0.7S6,15.1,5.5,14.5 c-0.4-0.4-0.7-1.1-0.7-1.8c0-0.6,0.2-1.3,0.7-1.7l2-1.9c1.2-1.3,2.5-1.5,3.5-0.5c0.2,0.2,0.2,0.6,0,0.9c-0.2,0.2-0.6,0.2-0.9,0 c-0.5-0.5-1.4,0-1.7,0.4l-2,1.9C6.1,12.1,6,12.4,6,12.7c0,0.3,0.1,0.6,0.3,0.8C6.7,14,7.6,14,8,13.6l0.5-0.5c0.2-0.2,0.6-0.2,0.9,0 C9.8,13.4,9.8,13.8,9.5,14z M14.5,9.1l-2.1,2.1c-0.6,0.6-1.4,0.9-2,0.9c-0.5,0-1.1-0.2-1.5-0.6c-0.2-0.2-0.2-0.6,0-0.9 c0.2-0.2,0.6-0.2,0.9,0c0.2,0.2,0.6,0.6,1.6-0.3l2.1-2.1c0.2-0.2,0.3-0.5,0.3-0.8s-0.1-0.6-0.3-0.8C13.2,6,12.5,5.8,12,6.3l-0.6,0.6 c-0.2,0.2-0.6,0.2-0.9,0c-0.2-0.2-0.2-0.6,0-0.9l0.6-0.6c0.9-0.9,2.3-0.8,3.4,0.1c0.4,0.4,0.7,1.1,0.7,1.8S15.1,8.5,14.5,9.1z"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgLink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/link.56ee19f50b6f6c0b7beb8a860afb86b7.svg";